import { NewsView } from '@/components/news/news-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/news')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'News' }
  }
})

function RouteComponent() {
  const { user, orpc } = Route.useRouteContext()

  return <NewsView user={user} orpc={orpc} />
}
